import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { objective: String, alternate: String, togglerCondition: String, showOnMatch: { type: Boolean, default: true } }

  connect() {
    if (this.element.type === "checkbox") {
      this.toggleCheckbox()
    } else {
      this.toggle()
    }
  }

  toggle() {
    this.showObjective(this.togglerConditionValue.split(",").includes(this.element.value) === this.showOnMatchValue)
  }

  toggleCheckbox() {
    this.showObjective(this.element.checked)
  }

  showObjective(visible) {
    document.querySelector(this.objectiveValue).classList.toggle("hidden", !visible)
    if (this.hasAlternateValue) document.querySelector(this.alternateValue).classList.toggle("hidden", visible)
  }
}
